/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseCourseModuleSettingsData } from './genericApiResponseCourseModuleSettingsData';
import type { GenericApiResponseCourseModuleSettingsMessage } from './genericApiResponseCourseModuleSettingsMessage';
import type { GenericApiResponseCourseModuleSettingsPagination } from './genericApiResponseCourseModuleSettingsPagination';
import type { GenericApiResponseCourseModuleSettingsError } from './genericApiResponseCourseModuleSettingsError';

export interface GenericApiResponseCourseModuleSettings {
  data?: GenericApiResponseCourseModuleSettingsData;
  message?: GenericApiResponseCourseModuleSettingsMessage;
  pagination?: GenericApiResponseCourseModuleSettingsPagination;
  error?: GenericApiResponseCourseModuleSettingsError;
  statusCode?: number;
}
